// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Gotham-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Gotham-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/IdealSans-Bold-Pro.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/IdealSans-Medium-Pro.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/Gotham-Condensed-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.bottom-3 {
  bottom: 0.75rem;
}
.right-2 {
  right: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-12 {
  height: 3rem;
}
.h-32 {
  height: 8rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.w-32 {
  width: 8rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-full {
  width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-4 {
  gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-56 {
  padding-bottom: 14rem;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}


@font-face {
  font-family: 'Gotham Medium';
  src: local('Gotham Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
  font-family: 'Gotham Bold';
  src: local('Gotham Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

@font-face {
  font-family: 'Ideal Sans Bold';
  src: local('Ideal Sans Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}

@font-face {
  font-family: 'Ideal Sans Medium';
  src: local('Ideal Sans Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}

@font-face {
  font-family: 'Gotham Condensed Bold';
  src: local('Gotham Condensed Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
}

.App {
  vertical-align: top;
  border-color:#8dc73f;
  border-style: solid;
  border-width: 3px;
  width:600px;
  height:300px;
  background-color: #333333;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: calc(10px + 1vmin);
  color: black;
  margin-left: auto;
  margin-right: auto;
  margin-bottom:400px;
  color: #D5D5D5;
}

.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width:975px;
  background-color: #FFFFFF;
  min-height: 55vh;
  margin-left: auto;
  margin-right: auto;
  /*font-size: calc(10px + 1vmin);*/
  color:black;
  padding:4px;
}

.no-shadow {
  /* Add shadows to create the "card" effect */
  width:975px;
  background-color: #FFFFFF;
  min-height: 55vh;
  margin-left: auto;
  margin-right: auto;
  /*font-size: calc(10px + 1vmin);*/
  color:black;
  padding:4px;
}

.small-card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width:675px;
  background-color: #FFFFFF;
  min-height: 45vh;
  margin-left: auto;
  margin-right: auto;
  /*font-size: calc(10px + 1vmin);*/
  color:black;
}

.selection-card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width:375px;
  background-color: #FFFFFF;
  min-height: 25vh;
  margin-left: auto;
  margin-right: auto;
  margin-bottom:12px;
  /*font-size: calc(10px + 1vmin);*/
  color:black;
}

/* On mouse-over, add a deeper shadow */
.card:hover, .small-card:hover, .selection-card:hover {
  box-shadow: 0 18px 32px 0 rgba(0,0,0,0.2);
}


.awesome-banner {
  background-color: #808080;
  color: white;
  height: 120px;
  text-align:center;
  font-size:34px;
  line-height: 104.27px;
}

.left-component { 
  float: left; 
  width: 50%; 
} 
 
.right-component { 
  float: right; 
  width: 50%; 
} 

.summary-label {
  color: #000000CC;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 500;
  line-height: 23.44px;
  text-align: left;
  


}

.summary-item {
  font-size:18px;
  font-weight: 500;
  color: #000000
}



/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}


button {
  background-color: #8dc73f;
  font-size: large;
  color: white;
}

.App-link {
  color: #61dafb;
}

.widget-title {
  font-size: 22px;
  line-height: 32px;
  /*border-bottom: 2px solid #8dc73f;*/
  color: black;
  padding-top: 30px;
    margin-bottom: 10px;
    font-weight: bold;
}

input[type="text"], input[type="password"]{
  color:#666666;
  border-color: B5B8C1;
  border-style: solid;
      border-width: 1px;
      height:38px;
      padding: 5px;

}

.front-page-input {
  width:100%
}

input:disabled {
  background-color: white;
}

.center-bottom {
  text-align: center;
  vertical-align: bottom;
}

.center{
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.loading-center{
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-button {
  display:flex;
  justify-content: center;
  align-items: center;
}

.landing-banner{
  padding:10px;
}

.myIframe {
  width: 2000px;
  height: 4540px;
  transform:scale(0.1);
  position: relative;
  left: -750px;
  top: -2600px;
}

.print-banner {
  width:2925px;
}

.summary-banner {
  width:158px;
}

.image-banner {
  position: relative;
  padding-top: 25px;
  color:white;
  min-height:370px;
}

.image-banner img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

/* Elementary Lighthouse banner text*/
.banner-text-Elementary-Lighthouse {
  color:white !important;
  z-index: 100;
  position:absolute;
  text-transform: uppercase;
  font-family: 'Ideal Sans Bold'
}
.summary-banner .banner-text-Elementary-Lighthouse {
  top:30px;
  left:60px;
  width: 98px;
  font-size: 12px;
}
.print-banner .banner-text-Elementary-Lighthouse {
  top:545px;
  left:1090px;
  width: 1700px;
}

/* Elementary Lighthouse year text*/
p.year-text-Elementary-Lighthouse {
  color:white !important;
  z-index: 100;
  position:absolute;
  transform: rotate(-8deg);
  font-family: 'Ideal Sans Medium'
}
.print-banner p.year-text-Elementary-Lighthouse {
  top:5535px;
  left:2255px;
  width: 680px;
  font-size: 110px;
}
.summary-banner p.year-text-Elementary-Lighthouse {
  top:294px;
  left:120px;
  width: 100px;
  font-size: 6px;
}

/*Elementary red banner text*/
.banner-text-Elementary {
  color:white !important;
  z-index: 100;
  text-transform: uppercase;
  font-family: 'Ideal Sans Bold'
  
}
.summary-banner .banner-text-Elementary {
  position:absolute;
  top:28px;
  left:60px;
  width: 98px;
  font-size: 12px;
}
.print-banner .banner-text-Elementary {
position:absolute;
top:545px;
left:1090px;
width: 1700px;
  

}

/*Elementary red year text*/
p.year-text-Elementary {
  color:white !important;
  z-index: 100;
  position:absolute;
  transform: rotate(-9deg);
  font-family: 'Ideal Sans Medium'
}
.summary-banner p.year-text-Elementary {
  top:288px;
  left:120px;
  width: 100px;
  font-size: 6px;
}
.print-banner p.year-text-Elementary {
  top:5430px;
  left:2220px;
  width: 680px;
  font-size: 120px;
}

/*Secondary banner text*/
.banner-text-Secondary {
  color:white !important;
  z-index: 100;
  position:absolute;
  text-transform: uppercase;
  font-family: 'Ideal Sans Bold'
}
.print-banner .banner-text-Secondary {
  top:532px;
  left:1090px;
  width: 1700px;
}
.summary-banner .banner-text-Secondary {
  top:30px;
  left:60px;
  width: 98px;
  font-size: 12px;
}

/*Secondary year text*/
p.year-text-Secondary {
  color:white !important;
  z-index: 100;
  position:absolute;
  transform: rotate(5deg);
  font-family: 'Ideal Sans Medium'
}
.summary-banner p.year-text-Secondary {
  top:291px;
  left:111px;
  width: 100px;
  font-size: 7px;
}
.print-banner p.year-text-Secondary {
  top:5340px;
  left:2070px;
  width: 680px;
  font-size: 110px;
}

/*Secondary Lighthouse banner text */
.banner-text-Secondary-Lighthouse {
  color:white !important;
  z-index: 100;
  position:absolute;
  text-transform: uppercase;
  font-family: 'Ideal Sans Bold'
}
.summary-banner .banner-text-Secondary-Lighthouse {
  top:29px;
  left:60px;
  width: 98px;
  font-size: 12px;
}
.print-banner .banner-text-Secondary-Lighthouse {
  top:536px;
  left:1090px;
  width: 1700px;
}

/*Secondary lighthouse year text */
p.year-text-Secondary-Lighthouse {
  color:white !important;
  z-index: 100;
  position:absolute;
  transform: rotate(5deg);
  font-family: 'Ideal Sans Medium'
}
.summary-banner p.year-text-Secondary-Lighthouse {
  top:291px;
  left:111px;
  width: 100px;
  font-size: 7px;
}
.print-banner p.year-text-Secondary-Lighthouse {
  top:5340px;
  left:2070px;
  width: 680px;
  font-size: 110px;
}

/* Legacy banner text */
.banner-text-Legacy {
  color:#001B49 !important;
  z-index: 100;
  position:absolute;
  text-transform: uppercase;
  font-family: 'Ideal Sans Bold'
}
.print-banner .banner-text-Legacy {
  top:5200px;
  left:330px;
  width: 2000px;
}
.summary-banner .banner-text-Legacy {
  top:279px;
  left:18px;
  width: 120px;
  font-size: 9px;
}

/*Legacy year text*/
p.year-text-Legacy {
  color:#001B49 !important;
  z-index: 100;
  position:absolute;
  font-family: 'Ideal Sans Medium'
}
.summary-banner p.year-text-Legacy {
  top:305px;
  left:18px;
  width: 100px;
  font-size: 9px;
}
.print-banner p.year-text-Legacy {
  top:5600px;
  left:330px;
  width: 2100px;
  font-size: 182px;
}

.orderId {
  top:6395px;
  left:2687px;
  font-size:17px;
  z-index:100;
  position: absolute;
}

.Legacy-orderId {
  color:#E6E7E8;
}

.Secondary-Lighthouse-orderId {
  color:#FFFFFF;
  opacity: 15%;
}

.Secondary-orderId {
  color:#FFFFFF;
  opacity: 15%;
}

.Elementary-orderId {
  color:#FFFFFF;
  opacity: 15%;
}

.Elementary-Lighthouse-orderId {
  color:#FFFFFF;
  opacity: 25%;

  
}


@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}


.hover\\:bg-lime-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}


.hover\\:underline:hover {
  text-decoration-line: underline;
}


.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}


@media (min-width: 640px) {

  .sm\\:w-1\\/2 {
    width: 50%;
  }
}


@media (min-width: 768px) {

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}


@media (min-width: 1024px) {

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;CAA0B;;AAA1B;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,4NAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;AAC1B;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;;;AAG/B;EACE,4BAA4B;EAC5B,uFAA4E;AAC9E;;AAEA;EACE,0BAA0B;EAC1B,qFAAwE;AAC1E;;AAEA;EACE,8BAA8B;EAC9B,yFAAmF;AACrF;;AAEA;EACE,gCAAgC;EAChC,2FAAuF;AACzF;;AAEA;EACE,oCAAoC;EACpC,+FAA4F;AAC9F;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;AAC3C;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;;;;AAIlB;;AAEA;EAEE,cAAc;EACd,gBAAgB;EAChB;AACF;;;;AAIA,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;;AAGA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;MACf,iBAAiB;MACjB,WAAW;MACX,YAAY;;AAElB;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EAId,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB;AACF;AACA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB;AACF;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB;;AAEF;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;AACA,iBAAiB;AACjB,SAAS;AACT,WAAW;AACX,aAAa;;;AAGb;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB;AACF;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB;AACF;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB;AACF;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB;AACF;AACA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB;AACF;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB;AACF;AACA;EACE,UAAU;EACV,UAAU;EACV,aAAa;AACf;AACA;EACE,SAAS;EACT,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB;AACF;AACA;EACE,SAAS;EACT,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;;;AAGd;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AArgBA;EAAA,kBAsgBA;EAtgBA;AAsgBA;;;AAtgBA;EAAA,kBAsgBA;EAtgBA;AAsgBA;;;AAtgBA;EAAA;AAsgBA;;;AAtgBA;EAAA;AAsgBA;;;AAtgBA;;EAAA;IAAA;EAsgBA;AAAA;;;AAtgBA;;EAAA;IAAA;EAsgBA;AAAA;;;AAtgBA;;EAAA;IAAA;EAsgBA;AAAA","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n\n@font-face {\n  font-family: 'Gotham Medium';\n  src: local('Gotham Medium'), url(fonts/Gotham-Medium.otf) format('opentype');\n}\n\n@font-face {\n  font-family: 'Gotham Bold';\n  src: local('Gotham Bold'), url(fonts/Gotham-Bold.otf) format('opentype');\n}\n\n@font-face {\n  font-family: 'Ideal Sans Bold';\n  src: local('Ideal Sans Bold'), url(fonts/IdealSans-Bold-Pro.otf) format('opentype');\n}\n\n@font-face {\n  font-family: 'Ideal Sans Medium';\n  src: local('Ideal Sans Medium'), url(fonts/IdealSans-Medium-Pro.otf) format('opentype');\n}\n\n@font-face {\n  font-family: 'Gotham Condensed Bold';\n  src: local('Gotham Condensed Bold'), url(fonts/Gotham-Condensed-Bold.otf) format('opentype');\n}\n\n.App {\n  vertical-align: top;\n  border-color:#8dc73f;\n  border-style: solid;\n  border-width: 3px;\n  width:600px;\n  height:300px;\n  background-color: #333333;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: calc(10px + 1vmin);\n  color: black;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom:400px;\n  color: #D5D5D5;\n}\n\n.card {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  width:975px;\n  background-color: #FFFFFF;\n  min-height: 55vh;\n  margin-left: auto;\n  margin-right: auto;\n  /*font-size: calc(10px + 1vmin);*/\n  color:black;\n  padding:4px;\n}\n\n.no-shadow {\n  /* Add shadows to create the \"card\" effect */\n  width:975px;\n  background-color: #FFFFFF;\n  min-height: 55vh;\n  margin-left: auto;\n  margin-right: auto;\n  /*font-size: calc(10px + 1vmin);*/\n  color:black;\n  padding:4px;\n}\n\n.small-card {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  width:675px;\n  background-color: #FFFFFF;\n  min-height: 45vh;\n  margin-left: auto;\n  margin-right: auto;\n  /*font-size: calc(10px + 1vmin);*/\n  color:black;\n}\n\n.selection-card {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  width:375px;\n  background-color: #FFFFFF;\n  min-height: 25vh;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom:12px;\n  /*font-size: calc(10px + 1vmin);*/\n  color:black;\n}\n\n/* On mouse-over, add a deeper shadow */\n.card:hover, .small-card:hover, .selection-card:hover {\n  box-shadow: 0 18px 32px 0 rgba(0,0,0,0.2);\n}\n\n\n.awesome-banner {\n  background-color: #808080;\n  color: white;\n  height: 120px;\n  text-align:center;\n  font-size:34px;\n  line-height: 104.27px;\n}\n\n.left-component { \n  float: left; \n  width: 50%; \n} \n \n.right-component { \n  float: right; \n  width: 50%; \n} \n\n.summary-label {\n  color: #000000CC;\n  font-family: DM Sans;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 23.44px;\n  text-align: left;\n  \n\n\n}\n\n.summary-item {\n  font-weight: 500;\n  font-size:18px;\n  font-weight: 500;\n  color: #000000\n}\n\n\n\n/* Add some padding inside the card container */\n.container {\n  padding: 2px 16px;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n\nbutton {\n  background-color: #8dc73f;\n  font-size: large;\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.widget-title {\n  font-size: 22px;\n  line-height: 32px;\n  /*border-bottom: 2px solid #8dc73f;*/\n  color: black;\n  padding-top: 30px;\n    margin-bottom: 10px;\n    font-weight: bold;\n}\n\ninput[type=\"text\"], input[type=\"password\"]{\n  color:#666666;\n  border-color: B5B8C1;\n  border-style: solid;\n      border-width: 1px;\n      height:38px;\n      padding: 5px;\n\n}\n\n.front-page-input {\n  width:100%\n}\n\ninput:disabled {\n  background-color: white;\n}\n\n.center-bottom {\n  text-align: center;\n  vertical-align: bottom;\n}\n\n.center{\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.loading-center{\n  height: 50vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.center-button {\n  display:flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.landing-banner{\n  padding:10px;\n}\n\n.myIframe {\n  width: 2000px;\n  height: 4540px;\n  -webkit-transform:scale(0.1);\n  -moz-transform:scale(0.1);\n  -o-transform:scale(0.1);\n  transform:scale(0.1);\n  position: relative;\n  left: -750px;\n  top: -2600px;\n}\n\n.print-banner {\n  width:2925px;\n}\n\n.summary-banner {\n  width:158px;\n}\n\n.image-banner {\n  position: relative;\n  padding-top: 25px;\n  color:white;\n  min-height:370px;\n}\n\n.image-banner img {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n/* Elementary Lighthouse banner text*/\n.banner-text-Elementary-Lighthouse {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  text-transform: uppercase;\n  font-family: 'Ideal Sans Bold'\n}\n.summary-banner .banner-text-Elementary-Lighthouse {\n  top:30px;\n  left:60px;\n  width: 98px;\n  font-size: 12px;\n}\n.print-banner .banner-text-Elementary-Lighthouse {\n  top:545px;\n  left:1090px;\n  width: 1700px;\n}\n\n/* Elementary Lighthouse year text*/\np.year-text-Elementary-Lighthouse {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  transform: rotate(-8deg);\n  font-family: 'Ideal Sans Medium'\n}\n.print-banner p.year-text-Elementary-Lighthouse {\n  top:5535px;\n  left:2255px;\n  width: 680px;\n  font-size: 110px;\n}\n.summary-banner p.year-text-Elementary-Lighthouse {\n  top:294px;\n  left:120px;\n  width: 100px;\n  font-size: 6px;\n}\n\n/*Elementary red banner text*/\n.banner-text-Elementary {\n  color:white !important;\n  z-index: 100;\n  text-transform: uppercase;\n  font-family: 'Ideal Sans Bold'\n  \n}\n.summary-banner .banner-text-Elementary {\n  position:absolute;\n  top:28px;\n  left:60px;\n  width: 98px;\n  font-size: 12px;\n}\n.print-banner .banner-text-Elementary {\nposition:absolute;\ntop:545px;\nleft:1090px;\nwidth: 1700px;\n  \n\n}\n\n/*Elementary red year text*/\np.year-text-Elementary {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  transform: rotate(-9deg);\n  font-family: 'Ideal Sans Medium'\n}\n.summary-banner p.year-text-Elementary {\n  top:288px;\n  left:120px;\n  width: 100px;\n  font-size: 6px;\n}\n.print-banner p.year-text-Elementary {\n  top:5430px;\n  left:2220px;\n  width: 680px;\n  font-size: 120px;\n}\n\n/*Secondary banner text*/\n.banner-text-Secondary {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  text-transform: uppercase;\n  font-family: 'Ideal Sans Bold'\n}\n.print-banner .banner-text-Secondary {\n  top:532px;\n  left:1090px;\n  width: 1700px;\n}\n.summary-banner .banner-text-Secondary {\n  top:30px;\n  left:60px;\n  width: 98px;\n  font-size: 12px;\n}\n\n/*Secondary year text*/\np.year-text-Secondary {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  transform: rotate(5deg);\n  font-family: 'Ideal Sans Medium'\n}\n.summary-banner p.year-text-Secondary {\n  top:291px;\n  left:111px;\n  width: 100px;\n  font-size: 7px;\n}\n.print-banner p.year-text-Secondary {\n  top:5340px;\n  left:2070px;\n  width: 680px;\n  font-size: 110px;\n}\n\n/*Secondary Lighthouse banner text */\n.banner-text-Secondary-Lighthouse {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  text-transform: uppercase;\n  font-family: 'Ideal Sans Bold'\n}\n.summary-banner .banner-text-Secondary-Lighthouse {\n  top:29px;\n  left:60px;\n  width: 98px;\n  font-size: 12px;\n}\n.print-banner .banner-text-Secondary-Lighthouse {\n  top:536px;\n  left:1090px;\n  width: 1700px;\n}\n\n/*Secondary lighthouse year text */\np.year-text-Secondary-Lighthouse {\n  color:white !important;\n  z-index: 100;\n  position:absolute;\n  transform: rotate(5deg);\n  font-family: 'Ideal Sans Medium'\n}\n.summary-banner p.year-text-Secondary-Lighthouse {\n  top:291px;\n  left:111px;\n  width: 100px;\n  font-size: 7px;\n}\n.print-banner p.year-text-Secondary-Lighthouse {\n  top:5340px;\n  left:2070px;\n  width: 680px;\n  font-size: 110px;\n}\n\n/* Legacy banner text */\n.banner-text-Legacy {\n  color:#001B49 !important;\n  z-index: 100;\n  position:absolute;\n  text-transform: uppercase;\n  font-family: 'Ideal Sans Bold'\n}\n.print-banner .banner-text-Legacy {\n  top:5200px;\n  left:330px;\n  width: 2000px;\n}\n.summary-banner .banner-text-Legacy {\n  top:279px;\n  left:18px;\n  width: 120px;\n  font-size: 9px;\n}\n\n/*Legacy year text*/\np.year-text-Legacy {\n  color:#001B49 !important;\n  z-index: 100;\n  position:absolute;\n  font-family: 'Ideal Sans Medium'\n}\n.summary-banner p.year-text-Legacy {\n  top:305px;\n  left:18px;\n  width: 100px;\n  font-size: 9px;\n}\n.print-banner p.year-text-Legacy {\n  top:5600px;\n  left:330px;\n  width: 2100px;\n  font-size: 182px;\n}\n\n.orderId {\n  top:6395px;\n  left:2687px;\n  font-size:17px;\n  z-index:100;\n  position: absolute;\n}\n\n.Legacy-orderId {\n  color:#E6E7E8;\n}\n\n.Secondary-Lighthouse-orderId {\n  color:#FFFFFF;\n  opacity: 15%;\n}\n\n.Secondary-orderId {\n  color:#FFFFFF;\n  opacity: 15%;\n}\n\n.Elementary-orderId {\n  color:#FFFFFF;\n  opacity: 15%;\n}\n\n.Elementary-Lighthouse-orderId {\n  color:#FFFFFF;\n  opacity: 25%;\n\n  \n}\n\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
